@if (!editMode) {
  <div class="inlineEditorContainer inlineTextArea" >
    @if (label) {
      <span
        [ngClass]="{ 'inline-text-label': true, 'disabled':disabledFlag }"
        >
        {{label}}
      </span>
    }
    <div
      (click)="changeToEdit($event)"
      [ngClass]="{'editable': true, 'editable-text':true, 'currency':true, 'disabled':disabledFlag}"
      aria-label='click to edit'
      tabindex="0"
      >{{ data | currency }}
    </div>
  </div>
}
@if (editMode) {
  <div class="inlineEditorTextContainer inlineEditArea weaveText">
    @if (label) {
      <label for="inlineField">{{label}}</label>
    }
    <input
      id="inlineField"
      class="weaveCurrency"
      [(ngModel)]='data'
      appAutofocus
      (blur)="onFocusOut()"
      (focusin)="startEdit()"
      (keydown.escape)="undo()"
      currencyMask
      [options]="{ prefix: '$', thousands: ',', decimal: '.' }"
      >
    </div>
  }
